'use client'

import { createContext, useContext, useState, useCallback } from 'react'
import type { Breadcrumb } from '../types'

interface BreadcrumbContextType {
  breadcrumb: Breadcrumb[]
  setBreadcrumb: (title: string, description: string) => void
}

const BreadcrumbContext = createContext<BreadcrumbContextType | undefined>(
  undefined
)

export const BreadcrumbProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [breadcrumb, setBreadcrumbState] = useState<Breadcrumb[]>([])

  const setBreadcrumb = useCallback((title: string, description: string) => {
    setBreadcrumbState([{ title, description }])
  }, [])

  return (
    <BreadcrumbContext.Provider value={{ breadcrumb, setBreadcrumb }}>
      {children}
    </BreadcrumbContext.Provider>
  )
}

export const useBreadcrumb = () => {
  const context = useContext(BreadcrumbContext)
  if (!context)
    throw new Error('useBreadcrumb must be used within a BreadcrumbProvider')
  return context
}
